import { render, staticRenderFns } from "./organisationsInviteDialog.vue?vue&type=template&id=2b63ab45&"
import script from "./organisationsInviteDialog.vue?vue&type=script&lang=js&"
export * from "./organisationsInviteDialog.vue?vue&type=script&lang=js&"
import style0 from "./organisationsInviteDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports